import React, { useMemo, useState } from "react"
import PropTypes from "prop-types"
import { Space, Descriptions, Row, Col, Tag, Typography } from "antd"

import { W1 } from "@components/constants"
import Identity from "@components/Identity"
import { Drawer } from "@components/Page"
import FormattedValue from "@components/FormattedValue"
import { JsonMarkdown } from "@components/Markdown"

const LABEL_ACTIVITY = "Activity"


const ActivityDrawer = ({ drawer, renderActivity }) => {
  const [ activity, setActivity ] = useState()

  const summaryItems = useMemo(() => !activity ? [] : [
    {
      key: 'operationId',
      label: 'Operation',
      children: activity.operationId,
    },
    ...(activity.investorAccountId
      ? [{
        key: 'investorAccountId',
        label: 'Investor',
        children: <Identity id={activity.investorAccountId} />,
      }] : []
    ),
    {
      key: 'createdAt',
      label: 'Created At',
      children: <FormattedValue value={activity.createdAt} />,
    },
    {
      key: 'userId',
      label: 'Created By',
      children: <Identity id={activity.userId} />
    },
  ], [ activity ])

  const sourceItems = useMemo(() => !activity ? [] : [
    {
      key: 'summary',
      label: 'Summary',
      children: renderActivity(activity),
    },
    {
      key: 'parameters',
      label: 'Parameters',
      children: <JsonMarkdown json={(activity.parametersJson || "{}")} />,
    },
    {
      key: 'output',
      label: 'Output',
      children: <JsonMarkdown json={(activity.resultJson || "{}")} />,
    },
  ], [ activity ])

  const title = useMemo(() => (
    <Row>
      <Col flex="auto">
        <Typography.Title level={5} style={{ margin: 0 }}>
          {LABEL_ACTIVITY}
        </Typography.Title>
      </Col>
      <Col>
        <Tag bordered={false}>
          {activity?.id}
        </Tag>
      </Col>
    </Row>
  ), [ activity ])

  return (
    <Drawer
      title={title}
      drawer={drawer}
      onOpen={setActivity}
      destroyOnClose={true}
    >
      <Space
        size={W1}
        style={{ width: "100%" }}
        direction="vertical"
      >
        <Descriptions
          size="small"
          items={summaryItems}
          column={1}
          bordered={true}
        />

        <Descriptions
          size="small"
          style={{ overflow: "hidden" }}
          items={sourceItems}
          layout="vertical"
          column={1}
          bordered={true}
        />
      </Space>
    </Drawer>
  )
}

ActivityDrawer.propTypes = {
  drawer: PropTypes.shape().isRequired,
  renderActivity: PropTypes.func.isRequired,
}

export default ActivityDrawer
